export enum TopTraders {
  ALL_TIME = "ALL_TIME",
  Past30D = "30D",
  Past7D = "7D",
  Past24H = "24H",
  Past1H = "1H",
}

export enum FilterName {
  TimeWindow = "timeWindow",
}

export const TOP_TRADERS_TABS = [
  TopTraders.ALL_TIME,
  TopTraders.Past30D,
  TopTraders.Past7D,
  TopTraders.Past24H,
  TopTraders.Past1H,
];

export const COLUMNS_WIDTH = [25, 16, 16, 13, 13, 13, 4];

export enum TopTradersFilterFields {
  traderPublicKey = "traderPublicKey",
  totalVolumeUsd = "totalVolumeUsd",
}
